module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "feature-area section-padding2 toubugaodu",
    staticStyle: {
      "height": "400px",
      "background": "url('../static/assets/images/bannerc.jpg') no-repeat",
      "background-size": "100% auto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "about_tab"
  }, [_c('router-link', {
    staticClass: "about_tab_jj",
    attrs: {
      "to": "/about"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业简介")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_wh",
    attrs: {
      "to": "/wenhua"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业文化")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_jg",
    attrs: {
      "to": "/jiagou"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业架构")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_zr",
    attrs: {
      "to": "/zeren"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("认证体系")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_sm",
    staticStyle: {
      "background": "#0473db",
      "color": "#ffffff"
    },
    attrs: {
      "to": "/shengming"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("版权声明")])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2 shengming_section1"
  }, [_c('div', {
    staticClass: "shengming_section1_one"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "animate fadeInRight40 animated shengmingkuandu",
    staticStyle: {
      "width": "50%",
      "float": "right",
      "font-size": "16px"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.aboutinfo.content)
    }
  })])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row toubugaoduzt",
    staticStyle: {
      "height": "400px",
      "line-height": "400px",
      "color": "#ffffff",
      "font-size": "45px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('p', {
    staticStyle: {
      "font-style": "initial"
    }
  }, [_vm._v("关于我们")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shengming_section1_one_1"
  }, [_c('div', {
    staticClass: "shengming_section1_one_2 animate fadeInLeft animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.5s",
      "visibility": "visible"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/banquan.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shengming_section1_one_3"
  }, [_c('img', {
    staticClass: "animate zoomIn animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "src": "/static/assets/images/banquan01.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shengming_section1_one_4 animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "1.5s",
      "visibility": "visible"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/banquan02.jpg"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-area section-padding2 shengming_section2 buxianshi"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "200px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://register.ccopyright.com.cn/query.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "index-banner"
  }, [_c('div', {
    staticClass: "g_w1200"
  }, [_c('div', {
    staticClass: "index-search"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("登记公告检索")]), _vm._v(" "), _c('div', {
    staticClass: "search",
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_c('ul', {
    staticClass: "tabs g_clearfix",
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_c('li', {
    staticClass: "current",
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_vm._v("查软件")]), _vm._v(" "), _c('li', {
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_vm._v("查作品")]), _vm._v(" "), _c('li', {
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_vm._v("查DCI")])]), _vm._v(" "), _c('ul', {
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_c('li', {
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_c('div', {
    staticClass: "search_box g_clearfix",
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_c('div', {
    staticClass: "input_box",
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_c('input', {
    staticClass: "input_register",
    attrs: {
      "data-v-7dec1380": "",
      "type": "text",
      "placeholder": "请输入精准登记号"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input_name",
    attrs: {
      "data-v-7dec1380": "",
      "type": "text",
      "placeholder": "请输入著作权人或软件名称"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button",
    attrs: {
      "data-v-7dec1380": ""
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "search_tips g_clearfix",
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_c('li', {
    staticClass: "title",
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_vm._v("例如：")]), _vm._v(" "), _c('li', {
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_vm._v("2018SR13332 美图美化修图软件")])]), _vm._v(" "), _c('ul', {
    staticClass: "search_subTips g_clearfix",
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_c('li', {
    staticClass: "title",
    attrs: {
      "data-v-7dec1380": ""
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-v-7dec1380": ""
    }
  }, [_vm._v("如需检索软件登记事项变更或补充登记，请输入登记号和变更后的著作权人或软件名称")])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc7dc824"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Shengming.vue
// module id = 119
// module chunks = 0